module.exports = __webpack_public_path__ + "img/Unova2Preview.37b479dc.png";